import { render } from "./IntegracaoInternaEvento.vue?vue&type=template&id=24739064"
import script from "./IntegracaoInternaEvento.vue?vue&type=script&lang=js"
export * from "./IntegracaoInternaEvento.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__